import React from 'react';

export default function ChatCircleIcon({
  width = 24,
  height = 24,
  fill = '#171C33',
  fillOpacity = 0.5,
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0002 2.25C10.3169 2.24963 8.66213 2.68508 7.19704 3.51396C5.73194 4.34285 4.50641 5.53692 3.63971 6.97997C2.77302 8.42301 2.29469 10.0659 2.25129 11.7486C2.20789 13.4314 2.60089 15.0967 3.39205 16.5825L2.32799 19.7747C2.23985 20.039 2.22706 20.3226 2.29105 20.5938C2.35504 20.8649 2.49328 21.1129 2.69029 21.3099C2.88729 21.5069 3.13526 21.6451 3.40642 21.7091C3.67757 21.7731 3.96119 21.7603 4.22549 21.6722L7.41768 20.6081C8.72527 21.3036 10.1741 21.6921 11.6543 21.744C13.1344 21.7959 14.6069 21.51 15.9601 20.9079C17.3132 20.3057 18.5114 19.4033 19.4636 18.269C20.4159 17.1346 21.0972 15.7983 21.4559 14.3613C21.8146 12.9244 21.8412 11.4246 21.5337 9.97578C21.2263 8.52701 20.5928 7.16732 19.6813 5.99992C18.7699 4.83253 17.6045 3.88811 16.2736 3.23836C14.9427 2.58861 13.4812 2.25061 12.0002 2.25ZM12.0002 20.25C10.5498 20.251 9.12495 19.8691 7.86955 19.1428C7.77763 19.0895 7.67544 19.0563 7.56974 19.0455C7.46404 19.0347 7.35724 19.0464 7.25643 19.08L3.75018 20.25L4.91924 16.7438C4.95294 16.643 4.96485 16.5362 4.95418 16.4305C4.94351 16.3248 4.91051 16.2226 4.85736 16.1306C3.94796 14.5584 3.58284 12.7299 3.81864 10.929C4.05444 9.12801 4.87798 7.4552 6.16151 6.17006C7.44503 4.88491 9.11679 4.05925 10.9175 3.82118C12.7181 3.5831 14.547 3.94591 16.1204 4.85333C17.6938 5.76074 18.9238 7.16204 19.6196 8.83983C20.3153 10.5176 20.4379 12.3781 19.9684 14.1327C19.4989 15.8873 18.4634 17.4379 17.0227 18.5439C15.582 19.65 13.8165 20.2497 12.0002 20.25Z"
        fill={fill}
        fillOpacity={fillOpacity}
      />
    </svg>
  );
}
